import { render, staticRenderFns } from "./pingfenxiangqing.vue?vue&type=template&id=80b1822e&scoped=true"
import script from "./pingfenxiangqing.vue?vue&type=script&lang=js"
export * from "./pingfenxiangqing.vue?vue&type=script&lang=js"
import style0 from "./pingfenxiangqing.vue?vue&type=style&index=0&id=80b1822e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b1822e",
  null
  
)

export default component.exports